import React from 'react'

import JobStatusBadge from '#/components/badges/JobStatusBadge'

const TypeJobStatusBadge = ({ value }) => {
  if (!value) return <span>-</span>
  return <JobStatusBadge status={value} />
}
export default TypeJobStatusBadge
